import { fetchPublicAPI } from "hooks/usePublicAPI";

import { availabilityPath, parseAvailability } from "./availability";
import {
  availabilityKey,
  type AvailabilityQuery,
  type AvailabilityStatus,
} from "./flow";

const REQUEST_TIMEOUT_MS = 3000;

/** Asks whether the area is served. A slow or failed call is "unknown":
 * the form never blocks on it. */
export async function fetchAvailability(
  query: AvailabilityQuery,
): Promise<{ key: string; status: AvailabilityStatus }> {
  const key = availabilityKey(query);
  const timeout = new Promise<AvailabilityStatus>((resolve) => {
    window.setTimeout(() => resolve("unknown"), REQUEST_TIMEOUT_MS);
  });
  const request = fetchPublicAPI<unknown>(availabilityPath(query))
    .then(parseAvailability)
    .catch((): AvailabilityStatus => "unknown");
  return { key, status: await Promise.race([request, timeout]) };
}
